{
  "name": "@carrierllc/mcp",
  "version": "0.13.3",
  "description": "Carrier MCP \u2014 natural-language control of MVNO/eSIM fleets via eSIMVault OCS. Stdio mode for direct integration with Claude Desktop, Cursor, Windsurf, and MCP-compatible clients. Ships the `carrier` CLI (plugin install + white-label eSIM storefront scaffold).",
  "license": "MIT",
  "author": "Carrier (Lifecycle Innovations Limited)",
  "homepage": "https://mcp.carrier.llc",
  "repository": {
    "type": "git",
    "url": "https://github.com/Lifecycle-Innovations-Limited/carrier.llc"
  },
  "type": "module",
  "main": "./dist/index.js",
  "files": [
    "dist",
    "plugin",
    "README.md",
    "templates",
    "!templates/**/node_modules",
    "!templates/**/.open-next",
    "!templates/**/.next",
    "!templates/**/.turbo",
    "!templates/**/.vercel",
    "!templates/**/.wrangler",
    "!templates/**/*.tsbuildinfo",
    "!templates/**/.env.local"
  ],
  "scripts": {
    "build": "tsup",
    "type-check": "tsc --noEmit",
    "lint": "eslint src",
    "prepublishOnly": "pnpm run build",
    "build:test": "tsup --config tsup.test.config.ts",
    "test": "pnpm run build && pnpm run build:test && node --test test/*.test.js",
    "check:pack": "node scripts/check-pack-size.mjs",
    "generate:domains": "node scripts/generate-domains.mjs"
  },
  "dependencies": {
    "@clack/prompts": "^0.7.0",
    "@clerk/backend": "^3.18.1",
    "@modelcontextprotocol/ext-apps": "^1.7.5",
    "@modelcontextprotocol/sdk": "^1.30.0",
    "@noble/hashes": "^2.3.0",
    "@sentry/cloudflare": "^10.65.0",
    "aws4fetch": "^1.0.20",
    "commander": "^15.0.0",
    "picocolors": "^1.1.1",
    "zod": "^4.4.3"
  },
  "devDependencies": {
    "@cloudflare/workers-types": "^5.20260903.1",
    "@types/node": "^26.1.2",
    "@typescript-eslint/eslint-plugin": "^8.59.4",
    "@typescript-eslint/parser": "^8.69.0",
    "eslint": "^10.9.1",
    "tsup": "^8.5.1",
    "typescript": "^5.9.3",
    "@carrier/ai": "workspace:*",
    "@carrier/ocs-client": "workspace:*",
    "@carrier/ocs-spec": "workspace:*",
    "@carrier/screens": "workspace:*"
  },
  "keywords": [
    "mcp",
    "model-context-protocol",
    "esim",
    "mvno",
    "carrier",
    "fleet-management",
    "esimvault"
  ],
  "engines": {
    "node": ">=22"
  },
  "publishConfig": {
    "access": "public"
  },
  "bin": {
    "carrier-mcp": "dist/index.js",
    "carrier": "dist/cli.js"
  }
}
